import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sws-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/about/about.component.ts